function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,6.429h30v17.143H0V6.429Z",
    style: {
      fill: "#da0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,6.429h30v11.429H0V6.429Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,6.429h30v5.714H0v-5.714Z",
    style: {
      fill: "#239f40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.933,11.876h-.666v-.267h-.4v.133h.267v.133h-.4v-.4h.533v-.267h.133v.533h.133v-.533h.133v.533h.134v-.533h.133s0,.668,0,.668ZM1.6,11.876h-.667v-.267h-.4v.267h-.133v-.4h.667v.267h.4v-.133h-.267v-.133h.4v.399ZM.8,11.876h-.133v-.133h.133v.133ZM2.133,11.343H.4v-.133h1.733s0,.133,0,.133Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.933,12.276h-1.2v-.267h1.2v.267ZM1.6,12.276H.4v-.267h1.2v.267Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.933,17.99h-1.2v-.267h1.2v.267ZM1.6,17.99H.4v-.267h1.2v.267Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.933,18.791h-.666v-.267h-.4v.133h.267v.133h-.4v-.4h.533v-.267h.133v.533h.133v-.533h.133v.533h.134v-.533h.133s0,.668,0,.668ZM1.6,18.791h-.667v-.267h-.4v.267h-.133v-.4h.667v.267h.4v-.133h-.267v-.133h.4v.399ZM.8,18.791h-.133v-.133h.133v.133ZM2.133,18.257H.4v-.133h1.733s0,.133,0,.133Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6,11.876h-.667v-.267h-.4v.133h.267v.133h-.4v-.4h.533v-.267h.133v.533h.134v-.533h.133v.533h.133v-.533h.134v.668ZM4.267,11.876h-.667v-.267h-.4v.267h-.133v-.4h.667v.267h.4v-.133h-.267v-.133h.4v.399ZM3.467,11.876h-.134v-.133h.133v.133h.001ZM4.8,11.343h-1.733v-.133h1.733v.133Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6,12.276h-1.2v-.267h1.2s0,.267,0,.267ZM4.267,12.276h-1.2v-.267h1.2v.267Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6,17.99h-1.2v-.267h1.2s0,.267,0,.267ZM4.267,17.99h-1.2v-.267h1.2v.267Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6,18.791h-.667v-.267h-.4v.133h.267v.133h-.4v-.4h.533v-.267h.133v.533h.134v-.533h.133v.533h.133v-.533h.134v.668ZM4.267,18.791h-.667v-.267h-.4v.267h-.133v-.4h.667v.267h.4v-.133h-.267v-.133h.4v.399ZM3.467,18.791h-.134v-.133h.133v.133h.001ZM4.8,18.257h-1.733v-.133h1.733v.133Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.267,11.876h-.667v-.267h-.4v.133h.267v.133h-.4v-.4h.533v-.267h.133v.533h.133v-.533h.134v.533h.133v-.533h.133v.668h0ZM6.933,11.876h-.666v-.267h-.4v.267h-.134v-.4h.667v.267h.4v-.133h-.267v-.133h.4v.399ZM6.133,11.876h-.133v-.133h.133v.133ZM7.467,11.343h-1.734v-.133h1.733v.133h.001Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.267,12.276h-1.2v-.267h1.2v.267ZM6.933,12.276h-1.2v-.267h1.2s0,.267,0,.267Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.267,17.99h-1.2v-.267h1.2v.267ZM6.933,17.99h-1.2v-.267h1.2s0,.267,0,.267Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.267,18.791h-.667v-.267h-.4v.133h.267v.133h-.4v-.4h.533v-.267h.133v.533h.133v-.533h.134v.533h.133v-.533h.133v.668h0ZM6.933,18.791h-.666v-.267h-.4v.267h-.134v-.4h.667v.267h.4v-.133h-.267v-.133h.4v.399ZM6.133,18.791h-.133v-.133h.133v.133ZM7.467,18.257h-1.734v-.133h1.733v.133h.001Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.933,11.876h-.667v-.267h-.4v.133h.267v.133h-.4v-.4h.533v-.267h.134v.533h.133v-.533h.133v.533h.134v-.533h.133s0,.668,0,.668ZM9.6,11.876h-.667v-.267h-.4v.267h-.133v-.4h.667v.267h.4v-.133h-.267v-.133h.4s0,.399,0,.399ZM8.8,11.876h-.133v-.133h.133v.133ZM10.133,11.343h-1.733v-.133h1.733s0,.133,0,.133Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.933,12.276h-1.2v-.267h1.2v.267ZM9.6,12.276h-1.2v-.267h1.2s0,.267,0,.267Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.933,17.99h-1.2v-.267h1.2v.267ZM9.6,17.99h-1.2v-.267h1.2s0,.267,0,.267Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.933,18.791h-.667v-.267h-.4v.133h.267v.133h-.4v-.4h.533v-.267h.134v.533h.133v-.533h.133v.533h.134v-.533h.133s0,.668,0,.668ZM9.6,18.791h-.667v-.267h-.4v.267h-.133v-.4h.667v.267h.4v-.133h-.267v-.133h.4s0,.399,0,.399ZM8.8,18.791h-.133v-.133h.133v.133ZM10.133,18.257h-1.733v-.133h1.733s0,.133,0,.133Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6,11.876h-.667v-.267h-.4v.133h.267v.133h-.4v-.4h.533v-.267h.133v.533h.134v-.533h.133v.533h.133v-.533h.134v.668ZM12.267,11.876h-.667v-.267h-.4v.267h-.133v-.4h.667v.267h.4v-.133h-.267v-.133h.4s0,.399,0,.399ZM11.467,11.876h-.133v-.133h.133v.133ZM12.8,11.343h-1.733v-.133h1.733v.133Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6,12.276h-1.2v-.267h1.2v.267ZM12.267,12.276h-1.2v-.267h1.2v.267Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6,17.99h-1.2v-.267h1.2v.267ZM12.267,17.99h-1.2v-.267h1.2v.267Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6,18.791h-.667v-.267h-.4v.133h.267v.133h-.4v-.4h.533v-.267h.133v.533h.134v-.533h.133v.533h.133v-.533h.134v.668ZM12.267,18.791h-.667v-.267h-.4v.267h-.133v-.4h.667v.267h.4v-.133h-.267v-.133h.4s0,.399,0,.399ZM11.467,18.791h-.133v-.133h.133v.133ZM12.8,18.257h-1.733v-.133h1.733v.133Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.267,11.876h-.667v-.267h-.4v.133h.267v.133h-.4v-.4h.533v-.267h.133v.533h.133v-.533h.134v.533h.133v-.533h.133v.668h.001ZM14.933,11.876h-.667v-.267h-.4v.267h-.133v-.4h.667v.267h.4v-.133h-.267v-.133h.4s0,.399,0,.399ZM14.133,11.876h-.133v-.133h.133v.133ZM15.467,11.343h-1.733v-.133h1.733v.133Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.267,12.276h-1.2v-.267h1.2v.267ZM14.933,12.276h-1.2v-.267h1.2v.267Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.267,17.99h-1.2v-.267h1.2v.267ZM14.933,17.99h-1.2v-.267h1.2v.267Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.267,18.791h-.667v-.267h-.4v.133h.267v.133h-.4v-.4h.533v-.267h.133v.533h.133v-.533h.134v.533h.133v-.533h.133v.668h.001ZM14.933,18.791h-.667v-.267h-.4v.267h-.133v-.4h.667v.267h.4v-.133h-.267v-.133h.4s0,.399,0,.399ZM14.133,18.791h-.133v-.133h.133v.133ZM15.467,18.257h-1.733v-.133h1.733v.133Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.933,11.876h-.667v-.267h-.4v.133h.267v.133h-.4v-.4h.533v-.267h.134v.533h.133v-.533h.133v.533h.134v-.533h.133s0,.668,0,.668ZM17.6,11.876h-.667v-.267h-.4v.267h-.133v-.4h.667v.267h.4v-.133h-.267v-.133h.4v.399ZM16.8,11.876h-.133v-.133h.133v.133ZM18.133,11.343h-1.733v-.133h1.733v.133Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.933,12.276h-1.2v-.267h1.2v.267ZM17.6,12.276h-1.2v-.267h1.2v.267Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.933,17.99h-1.2v-.267h1.2v.267ZM17.6,17.99h-1.2v-.267h1.2v.267Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.933,18.791h-.667v-.267h-.4v.133h.267v.133h-.4v-.4h.533v-.267h.134v.533h.133v-.533h.133v.533h.134v-.533h.133s0,.668,0,.668ZM17.6,18.791h-.667v-.267h-.4v.267h-.133v-.4h.667v.267h.4v-.133h-.267v-.133h.4v.399ZM16.8,18.791h-.133v-.133h.133v.133ZM18.133,18.257h-1.733v-.133h1.733v.133Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6,11.876h-.667v-.267h-.4v.133h.267v.133h-.4v-.4h.533v-.267h.133v.533h.134v-.533h.133v.533h.133v-.533h.134v.668ZM20.267,11.876h-.667v-.267h-.4v.267h-.133v-.4h.667v.267h.4v-.133h-.267v-.133h.4v.399ZM19.467,11.876h-.133v-.133h.133v.133ZM20.8,11.343h-1.733v-.133h1.733v.133Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6,12.276h-1.2v-.267h1.2v.267ZM20.267,12.276h-1.2v-.267h1.2v.267Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6,17.99h-1.2v-.267h1.2v.267ZM20.267,17.99h-1.2v-.267h1.2v.267Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6,18.791h-.667v-.267h-.4v.133h.267v.133h-.4v-.4h.533v-.267h.133v.533h.134v-.533h.133v.533h.133v-.533h.134v.668ZM20.267,18.791h-.667v-.267h-.4v.267h-.133v-.4h.667v.267h.4v-.133h-.267v-.133h.4v.399ZM19.467,18.791h-.133v-.133h.133v.133ZM20.8,18.257h-1.733v-.133h1.733v.133Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.267,11.876h-.667v-.267h-.4v.133h.267v.133h-.4v-.4h.533v-.267h.133v.533h.133v-.533h.134v.533h.133v-.533h.133v.668h.001ZM22.933,11.876h-.667v-.267h-.4v.267h-.133v-.4h.667v.267h.4v-.133h-.267v-.133h.4s0,.399,0,.399ZM22.133,11.876h-.133v-.133h.133v.133ZM23.467,11.343h-1.733v-.133h1.733v.133Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.267,12.276h-1.2v-.267h1.2v.267ZM22.933,12.276h-1.2v-.267h1.2v.267Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.267,17.99h-1.2v-.267h1.2v.267ZM22.933,17.99h-1.2v-.267h1.2v.267Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.267,18.791h-.667v-.267h-.4v.133h.267v.133h-.4v-.4h.533v-.267h.133v.533h.133v-.533h.134v.533h.133v-.533h.133v.668h.001ZM22.933,18.791h-.667v-.267h-.4v.267h-.133v-.4h.667v.267h.4v-.133h-.267v-.133h.4s0,.399,0,.399ZM22.133,18.791h-.133v-.133h.133v.133ZM23.467,18.257h-1.733v-.133h1.733v.133Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.933,11.876h-.667v-.267h-.4v.133h.267v.133h-.4v-.4h.533v-.267h.134v.533h.133v-.533h.133v.533h.134v-.533h.133s0,.668,0,.668ZM25.6,11.876h-.667v-.267h-.4v.267h-.133v-.4h.667v.267h.4v-.133h-.267v-.133h.4v.399ZM24.8,11.876h-.133v-.133h.133v.133ZM26.133,11.343h-1.733v-.133h1.733v.133Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.933,12.276h-1.2v-.267h1.2v.267ZM25.6,12.276h-1.2v-.267h1.2v.267Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.933,17.99h-1.2v-.267h1.2v.267ZM25.6,17.99h-1.2v-.267h1.2v.267Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.933,18.791h-.667v-.267h-.4v.133h.267v.133h-.4v-.4h.533v-.267h.134v.533h.133v-.533h.133v.533h.134v-.533h.133s0,.668,0,.668ZM25.6,18.791h-.667v-.267h-.4v.267h-.133v-.4h.667v.267h.4v-.133h-.267v-.133h.4v.399ZM24.8,18.791h-.133v-.133h.133v.133ZM26.133,18.257h-1.733v-.133h1.733v.133Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6,11.876h-.667v-.267h-.4v.133h.267v.133h-.4v-.4h.533v-.267h.133v.533h.134v-.533h.133v.533h.133v-.533h.134v.668ZM28.267,11.876h-.667v-.267h-.4v.267h-.133v-.4h.667v.267h.4v-.133h-.267v-.133h.4v.399ZM27.467,11.876h-.133v-.133h.133v.133ZM28.8,11.343h-1.733v-.133h1.733v.133Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6,12.276h-1.2v-.267h1.2v.267ZM28.267,12.276h-1.2v-.267h1.2v.267Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6,17.99h-1.2v-.267h1.2v.267ZM28.267,17.99h-1.2v-.267h1.2v.267Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6,18.791h-.667v-.267h-.4v.133h.267v.133h-.4v-.4h.533v-.267h.133v.533h.134v-.533h.133v.533h.133v-.533h.134v.668ZM28.267,18.791h-.667v-.267h-.4v.267h-.133v-.4h.667v.267h.4v-.133h-.267v-.133h.4v.399ZM27.467,18.791h-.133v-.133h.133v.133ZM28.8,18.257h-1.733v-.133h1.733v.133Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.826,16.791c1.027.333,2.129-.23,2.462-1.257.242-.748.013-1.568-.582-2.082.662.981.403,2.313-.578,2.975-.384.259-.841.387-1.302.364",
    style: {
      fill: "#da0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.324,16.416c.782-.454,1.047-1.457.592-2.238-.221-.38-.586-.656-1.012-.764.945.713,1.133,2.056.421,3.001t-.001.001M15,17.143l-.107-2.143.107-1.686c.065.091.152.164.253.212v1.26l-.086,2.128-.167.229ZM14.957,13.179l.043.04c.095.142.286.18.428.086.124-.083.171-.242.112-.379-.029.158-.18.263-.339.235-.085-.015-.159-.068-.201-.143",
    style: {
      fill: "#da0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.174,16.791c-1.027.333-2.129-.23-2.462-1.257-.242-.748-.013-1.568.582-2.082-.662.981-.403,2.313.578,2.975.384.259.841.387,1.302.364",
    style: {
      fill: "#da0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.676,16.416c-.782-.454-1.047-1.457-.592-2.238.221-.38.586-.656,1.012-.764-.945.713-1.133,2.056-.421,3.001t.001.001M15,17.143l.107-2.143-.107-1.686c-.065.091-.152.164-.253.212v1.26l.086,2.128.167.229ZM15.043,13.179l-.043.04c-.095.142-.286.18-.428.086-.124-.083-.171-.242-.112-.379.029.158.18.263.339.235.085-.015.159-.068.201-.143",
    style: {
      fill: "#da0000"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIr);
export default __webpack_public_path__ + "static/media/IR.156224bd0c7ede6236d2bea9f7ae9c4f.svg";
export { ForwardRef as ReactComponent };